module.exports = __webpack_public_path__ + "img/city_newtaipei.3fbaace9.png";